var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7631",
    "data-name": "Group 7631",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.14,
    height: 11.796,
    viewBox: "0 0 11.14 11.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M10.64.5V10.589l-1.9-1.9H.5V.5Z",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M21.223,12.7v.711h-.711a4.513,4.513,0,0,1-3.69,3.724v-.711a3.776,3.776,0,0,0,2.962-3.013H16.5V12.7h4.723Z",
    transform: "translate(-13.291 -10.135)",
    fill: "var(--mainColor)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M24.235,23.185v.728A4.5,4.5,0,0,1,20.9,20.9h.745A3.739,3.739,0,0,0,24.235,23.185Z",
    transform: "translate(-16.947 -16.947)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.258255f8699efae835abae7523fb45b9.svg";
export { ForwardRef as ReactComponent };